import PaymentOptions from './PaymentOptions';

export default PaymentOptions;
